import request from "@/utils/request";
import store from "@/store";

// 获取急救车的列表
export function getAmbulanceInfo(id) {
  return request({
    url: "/srs/ambulance-data",
    method: "get",
    params: { token: store.state.userInfo.token, id, ifAmbulance: 1 }
  });
}
